<div class="admin-shell">
  <aside class="sidebar" aria-label="Admin navigation">
    <a class="brand" routerLink="/dashboard" aria-label="Pally admin home">
      <img class="brand-logo" src="Images/landingLogo.svg" alt="Access Bank" />
    </a>

    <nav class="nav-list">
      <a routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
        <svg class="nav-icon" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="4" y="4" width="6" height="6" rx="1"/><rect x="14" y="4" width="6" height="6" rx="1"/><rect x="4" y="14" width="6" height="6" rx="1"/><rect x="14" y="14" width="6" height="6" rx="1"/></svg>
        <span>Dashboard</span>
      </a>
      <a routerLink="/approver" routerLinkActive="active">
        <svg class="nav-icon" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><circle cx="12" cy="8" r="3"/><path d="M5 20c.7-3.3 3-5 7-5s6.3 1.7 7 5"/><path d="m17 14 2 2 4-4"/></svg>
        <span>Approval</span>
      </a>
      <a routerLink="/sub-tenants" routerLinkActive="active">
        <svg class="nav-icon" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="4" y="4" width="16" height="16" rx="2"/><path d="M8 8h8M8 12h8M8 16h5"/></svg>
        <span>Sub-tenants</span>
      </a>
    </nav>

    <div class="sidebar-footer">
      <button class="profile" type="button" [attr.aria-expanded]="profileMenuOpen()" aria-haspopup="menu" (click)="toggleProfileMenu()">
        <span class="avatar">{{ (authService.currentUser()?.firstName || 'A').charAt(0) }}</span>
        <span class="profile-copy">
          <strong>{{ authService.currentUser()?.firstName || 'Admin' }} {{ authService.currentUser()?.lastName || '' }}</strong>
          <small>{{ authService.currentUser()?.email || 'admin@pally.app' }}</small>
        </span>
        <span class="profile-chevron" aria-hidden="true">⌄</span>
      </button>
      @if (profileMenuOpen()) {
        <div class="profile-menu" role="menu">
          <button type="button" role="menuitem" (click)="logout(); closeProfileMenu()">
            <span aria-hidden="true">&#8594;</span>
            Sign out
          </button>
        </div>
      }
    </div>
  </aside>

  <main class="main-content">
    <section class="page-content">
      <router-outlet />
    </section>
  </main>
</div>
